import React from 'react';
import PropTypes from 'prop-types';
import { Block } from '@webfox-sc/core';
import { useDownloads } from './useDownloads';
import ContentSection from '../../atoms/ContentSection';
import AssetsWrapper from './AssetsWrapper';
import AssetItem from './AssetItem';

const DownloadLists = () => {
  const { allAssets } = useDownloads();

  return (
    <>
      <ContentSection paddingTop="30px">
        <Block className="bt-page-view-downloads__assets" paddingTop="30px">
          {allAssets.length > 0 ? (
            <AssetsWrapper>
              {allAssets.map((asset, index) => (
                <AssetItem key={`${asset.type}-${index}`} asset={asset} />
              ))}
            </AssetsWrapper>
          ) : (
            <Block className="bt-page-view-downloads__no-results">No results found</Block>
          )}
        </Block>
      </ContentSection>
    </>
  );
};

DownloadLists.propTypes = {
  speakerSearch: PropTypes.string,
};

DownloadLists.defaultProps = {
  speakerSearch: '',
};

export default DownloadLists;
